import { 
  OuterWrapper, 
  YouTubeWrapper 
} from './youtube-display.styles';

const YouTubeDisplay = ({ section }) => {
  const extractVideoEmbedUrl = (url) => {
    if (!url) return null;

    if (url.includes('youtube.com/embed/')) return url;

    const watchMatch = url.match(/[?&]v=([^&]+)/);
    if (watchMatch) return `https://www.youtube.com/embed/${watchMatch[1]}`;

    const shortMatch = url.match(/youtu\.be\/([^?&]+)/);
    if (shortMatch) return `https://www.youtube.com/embed/${shortMatch[1]}`;

    return null;
  };

  const { youtubeUrl } = section.content || {};
  const embedUrl = extractVideoEmbedUrl(youtubeUrl);

  if (!embedUrl) return null;

  return (
    <OuterWrapper>
      <YouTubeWrapper>
        <iframe
          src={embedUrl}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </YouTubeWrapper>
    </OuterWrapper>
  );
};

export default YouTubeDisplay;